module.exports = __webpack_public_path__ + "img/zidonghuoqu.2b676682.gif";